import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { DSB_PROGRAM_CODE } from './constants'
import { partnerFlagRequestTranslation } from './translation'

const DEFAULT_END_DATE = new Date('2099-12-31')

export const getDefaultStartDate = () => new Date()

export const getDefaultEndDate = () => new Date(DEFAULT_END_DATE)

export const DEFAULT_CRUD = new Crud<IProfilingCode>({
  fetcher: new Static([] as IProfilingCode[]),
  keyField: 'code',
})

export type PartnerFlagWarningConfig = {
  codes: string | string[]
  title: string
  content: string
  confirmBtnText?: string
  cancelBtnText?: string
}

export const PARTNER_FLAG_WARNING_CONFIGS: PartnerFlagWarningConfig[] = [
  {
    codes: [DSB_PROGRAM_CODE],
    title: partnerFlagRequestTranslation.warnings.DSB.title,
    content: partnerFlagRequestTranslation.warnings.DSB.content,
    cancelBtnText: partnerFlagRequestTranslation.warnings.DSB.cancelBtnText,
    confirmBtnText: partnerFlagRequestTranslation.warnings.DSB.confirmBtnText,
  },
]
